import styled from 'styled-components';

const VimeoHeroStyles = styled.div``;

export default VimeoHeroStyles;
